export const BUSINESSLOGO_IMAGE_TYPE = 'businesslogo';
export const BUSINESSLOGO_RESIZE_WIDTH = 200;
export const MESSAGEIMAGE_IMAGE_TYPE = 'messageimage';
export const MESSAGEIMAGE_RESIZE_WIDTH = 800;
export const UNKNOWN_IMAGE_TYPE = 'unknownimagetype';
export const IMAGE_TYPE_TAG_KEY = 'imagetype';
//# sourceMappingURL=images.js.map